<template>
    <div id="help-box" class="help-box" v-if="filteredData.length">
        <div v-show="helpBoxOpened" id="help-box-items">
            <div class="help-box__items">
                <div class="help-box__headline">
                    <div>
                        {{ trans('help.headline') }}
                    </div>
                    <button @click="toggleHelpBox">
                        &times;
                    </button>
                </div>
                <div v-for="(item, index) in filteredData" :key="index">
                    <div v-if="item.type == 'file'">
                        <a :href="item.url" target="_blank">
                            <div class="help-box__item">
                                {{ item.label }}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="help-box__button--round" @click="toggleHelpBox">
            <img class="icon" :src="iconUrl" :alt="iconAlt">
        </div>
    </div>
</template>

<script>
import { onClickOutside } from '../util/onClickOutside';

export default {
    props: [
        'roles',
    ],

    data() {
        return {
            helpBoxOpened: false,
            data: [
                {
                    type: 'file',
                    label: this.trans('help.label.clientadmin.documentation'),
                    url: '/files/DEKRA_SafetyWeb_Handbuch-Admin.pdf',
                    roles: [
                        'client_admin'
                    ]
                }
            ]
        }
    },

    methods: {
        toggleHelpBox() {
            this.helpBoxOpened = !this.helpBoxOpened;
        }
    },

    computed: {
        filteredData() {
            return this.data.filter(item => {
                let intersection = item.roles.filter(role => this.roles.includes(role));
                return intersection.length;
            });
        },
        iconUrl() {
            return `/images/icons/help.svg`;
        },

        iconAlt() {
            return `toggle help box`;
        }
    },

    mounted() {
        if (this.filteredData.length) {
            onClickOutside(document.getElementById('help-box'), () => { this.helpBoxOpened = false; });
        }
    },

}
</script>
